import { render, staticRenderFns } from "./ProductUpSell.vue?vue&type=template&id=3c42f950&scoped=true&"
import script from "./ProductUpSell.ts?vue&type=script&lang=js&"
export * from "./ProductUpSell.ts?vue&type=script&lang=js&"
import style0 from "./ProductUpSell.vue?vue&type=style&index=0&id=3c42f950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42f950",
  null
  
)

export default component.exports